export const SET_CLIENT_LOAD = 'SET_CLIENT_LOAD';
export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH';

export const setClientLoad = payload => {
  return dispatch => {
    dispatch({ type: SET_CLIENT_LOAD, payload });
  };
};

export const setWindowWidth = payload => {
  return dispatch => {
    dispatch({ type: SET_WINDOW_WIDTH, payload });
  };
};

export const initialBrowserWindowState = {
  hydrated: false,
  windowWidth: null,
  mobileBrowser: false,
  tabletBrowser: false
};

export default function browserWindow(state = initialBrowserWindowState, action) {
  switch (action.type) {
    case SET_CLIENT_LOAD:
      return { ...state, ...action.payload };
    case SET_WINDOW_WIDTH:
      return { ...state, windowWidth: action.payload };
    default:
      return state;
  }
}
